import { lazy, Suspense } from 'react';

const EventsApp = lazy(() =>
  import('hb-react/shared/apps/Events/startup/EventsApp'),
);

const TopicEventsContainer = (props) => {
  const eventsAppConfig = {
    routes: {
      event_path: (eventId, params) =>
        Routes.network_event_path(eventId, params),
      event_registration_path: (eventId, params) =>
        Routes.network_event_registration_path(eventId, params),
      event_attendees_path: (eventId, params) =>
        Routes.network_event_attendees_path(eventId, params),
      summary_ticket_event_attendees_path: (eventId, params) =>
        Routes.summary_ticket_network_event_attendees_path(eventId, params),
    },
  };

  return (
    <Suspense fallback={null}>
      <EventsApp config={eventsAppConfig} {...props} />
    </Suspense>
  );
};

export default TopicEventsContainer;
